module.exports = __webpack_public_path__ + "static/img/event9.da1e653.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event9.png
// module id = uIiF
// module chunks = 1